module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Kuar"))).then(() => parcelRequire('fThBo'));